var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_vm._v("Unknown component: "+_vm._s(_vm.componentData))])}
var staticRenderFns = []

export { render, staticRenderFns }